<template>
<div class="chapter">
<div class="inner_page">
<h1 class="heading"><span class="smallcaps">ALSO BY<br/></span> <br/><span class="smallcaps">JEAN-CLAUDE IZZO</span></h1>
<p class="center"><em class="italic"><a href="https://www.europaeditions.com/book/9781609454401/total-chaos" target="_blank">Total Chaos</a></em></p>
<p class="center"><em class="italic"><a href="http://www.europaeditions.com/book/9781609451271/chourmo" target="_blank">Chourmo</a></em></p>
<p class="center"><em class="italic"><a href="http://www.europaeditions.com/book/9781933372594/a-sun-for-the-dying" target="_blank">A Sun for the Dying</a></em></p>
<p class="center"><em class="italic"><a href="http://www.europaeditions.com/book/9781933372358/the-lost-sailors" target="_blank">The Lost Sailors</a></em></p>
<p class="center"><em class="italic">Living Tires</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// solea_00001.vue?6ee0d8e7